module.exports = __webpack_public_path__ + "static/media/postman.65245af1.svg";